/**
 * Shared min(from)-max(to) narrowing reducer for "resolved span across a set of
 * date ranges" computations. Used by both `inventory-availability-shared.tsx`'s
 * `resolveFreeCellDateRange` (raw selection + resolver input) and
 * `unified-select-reserve-confirm-dialog.tsx`'s `resolveDateRange` (pre-resolved
 * cell array input) — the two call sites pass different input shapes but fold
 * the same "reservable span of a selection" business rule, so both delegate to
 * this one reducer instead of re-implementing the `<`/`>` comparisons twice.
 */
export function narrowDateRange(
  current: { from: Date; to: Date } | null,
  candidate: { from: Date; to: Date },
): { from: Date; to: Date } {
  if (!current) return candidate;
  return {
    from: candidate.from < current.from ? candidate.from : current.from,
    to: candidate.to > current.to ? candidate.to : current.to,
  };
}
